import { OktaAuth } from '@okta/okta-auth-js'
import { OnAuthRequiredFunction } from '@okta/okta-react/bundles/types/OktaContext'

import * as logging from 'utils/Logging'
import * as paths from 'utils/Links'

function logAndRedirectToLoginPage(cause: string): void {
  logging.logInfo(cause)
  paths.serverRedirect('/sign-in')
}

export function customAuthHandler(oktaAuth: OktaAuth): OnAuthRequiredFunction {
  return () => {
    oktaAuth.token.getWithoutPrompt().then(
      (value) => {
        oktaAuth.handleLoginRedirect(value.tokens).then(() => {
          oktaAuth.authStateManager.updateAuthState().then(
            (value) => {
              if (!value.isAuthenticated) {
                logAndRedirectToLoginPage('sign in required')
              }
            },
            (error) => {
              logAndRedirectToLoginPage(error)
            },
          )
        })
      },
      (error) => {
        logAndRedirectToLoginPage(error.errorCode)
      },
    )
  }
}
